/**
 * Derive the Faro `environment` label from the browser's hostname.
 *
 * The storefront image is built once and Kargo-promoted stg→prd, and the Faro
 * collector URL (`NEXT_PUBLIC_FARO_URL`) is a single shared host baked at build
 * time — so the environment label can't be baked per-env. We derive it at
 * runtime from where the page is actually served instead:
 *
 *   - `localhost` / `*.localhost`     → "development"
 *   - `stg.tongkatfitness.{com,..}`   → "staging"   (all staging hosts are stg.*)
 *   - everything else (prd.* + apexes) → "production"
 */
export function faroEnvironmentFromHostname(hostname: string): string {
  if (hostname === "localhost" || hostname.endsWith(".localhost")) {
    return "development";
  }
  if (hostname.startsWith("stg.")) {
    return "staging";
  }
  return "production";
}
